import React, { useEffect, useState } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { LoaderScreen } from "../../components/LoaderScreen";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { useHistory } from "react-router-dom";
import DownloadingIcon from "@mui/icons-material/Downloading";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, Grid, Modal, TextField } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import DeleteIcon from '@mui/icons-material/Delete';

export const ListadoPagareScreen = () => {
  const history = useHistory();
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  const [data, setData] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleShowModal = (item) => {
    setSelectedCliente(item);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedCliente(null);
  };

  const capitalizeWords = (str) => {
    return str
      ? str
        .toLowerCase()
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
      : "";
  };

  useEffect(() => {
    cargarInfo()
  }, []);

  const cargarInfo = () => {
    setLoader({ ...loader, mostrar: true });
    request
      .get("ListadoPC/Editar")
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        setData(result);
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("LISTADO DE PRESTAMOS A CLIENTES", error.mensaje, "error");
      });
  }

  const onGeneraExcel = () => {
    setLoader({ ...loader, mostrar: true });

    request
      .get(`ListadoPC/GenerarExcel`)
      .then(({ documento, filename }) => {
        setLoader({ ...loader, mostrar: false });
        const linkSource = `data:application/vnd.ms-excel;base64,${documento}`;
        const downloadLink = document.createElement("a");
        const fileName = `${filename}.xlsx`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("CREDITO Y COBRANZA", JSON.stringify(error), "error");
      });
  };

  const onImprimirPedido = (iddocumento) => {
    setLoader({ ...loader, mostrar: true });
    request
      .get(
        `SolicitudCreditoDocumentacion/ObtenerPedidoFacturado?folio=${selectedCliente.folio
        }&iddocumento=${Number(iddocumento)}`
      )
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        if (
          result.length !== undefined &&
          result.length !== null &&
          result.length > 0
        ) {
          result.forEach((element) => {
            console.log(element);
            const linkSource =
              "data:application/pdf;base64," + element.documento;
            const downloadLink = document.createElement("a");
            const fileName = `${element.nombredocumento}.${element.extension}`;
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          });
          return;
        }

        const linkSource = result.comentarios;
        const downloadLink = document.createElement("a");
        const fileName = `${result.documento}.${result.extension}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire("PEDIDOS FACTURADOS", error.mensaje, "error");
      });
  };

  const onModalComentarios = (folio) => {
    // Mostrar confirmación antes de guardar
    Swal.fire({
      title: '¿Estás seguro de eliminarla?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'custom-confirm-button-cancel'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        onCancelarSolicitud("R", folio);
      }
    });
  };

  const onCancelarSolicitud = (accion, folio) => {
    setLoader({ ...loader, mostrar: true });

    const comentarios = "Solicitud cancelada por area de Cobranza"

    const post = {
      folio: folio,
      accion: accion,
      comentarios: comentarios,
    };
    request
      .post(`PanelControlSolicitudes`, post)
      .then((result) => {
        setLoader({ ...loader, mostrar: false });
        cargarInfo()
      })
      .catch((error) => {
        setLoader({ ...loader, mostrar: false });
        Swal.fire(
          "ANALISIS DE SOLICITUD DE CREDITO",
          JSON.stringify(error),
          "error"
        );
      });
  }

  return (
    <PlantillaScreen
      titulo={`LISTADO DE PRESTAMOS A CLIENTES`}
      className_main={1}
      className={"ListadoPC-Plantilla"}
    >
      <div className="ListadoPC-footer">
        <div
          className="ListadoPC-home-bc"
          onClick={() =>
            history.push("/Creditoycobranza/Main")
          }
        >
          <ArrowBackIcon /> Regresar
        </div>
        <div className="ListadoPC-footer-download">
          <button
            className="ListadoPCbutton-download-excel"
            onClick={onGeneraExcel}
          >
            <DownloadingIcon />
            Generar Excel
          </button>
        </div>
      </div>
      <LoaderScreen loader={loader} />
      <div className="Cob_Listado_Clientes_PC">
        <div className="cob_detalle scroll-4">
          <table cellPadding={0} cellSpacing={0}>
            <thead>
              <tr>
                <th>Sucursal</th>
                <th>Razon Social</th>
                <th>Documento</th>
                <th>Serie</th>
                <th>Vencimiento</th>
                <th>Importe</th>
                <th>Tasa</th>
                <th>Interes</th>
                <th>Total</th>
                <th>Saldo</th>
                <th colSpan={2}></th>
              </tr>
            </thead>
            <tbody>
              {data.map((element) => (
                <tr>
                  <td>{element.sucursal}</td>
                  <td>{element.razon_social}</td>
                  <td className="ta-center">{element.documento}</td>
                  <td className="ta-center">
                    {element.serie_fiscal === "-"
                      ? "-"
                      : `${element.serie_fiscal} - ${element.folio_fiscal}`}
                  </td>
                  <td className="ta-center">{element.vencimiento}</td>
                  <td className="ta-right">
                    {FormatMoney(element.importefinanciar, 2)}
                  </td>
                  <td className="ta-right">{FormatMoney(element.tasa, 2)}</td>
                  <td className="ta-right">
                    {FormatMoney(element.interes, 2)}
                  </td>
                  <td className="ta-right">
                    {FormatMoney(element.totalpagar, 2)}
                  </td>
                  <td className="ta-right">{FormatMoney(element.saldo, 2)}</td>
                  {element.documento !== "-" ? (
                    <td></td>
                  ) : (
                    <td>
                      <button
                      className="pc-listado-boton-cancelar"
                        onClick={() => onModalComentarios(element.folio)}
                      >
                        <DeleteIcon />
                        Cancelar
                      </button>
                    </td>
                  )}
                  <td>
                    <Button
                      variant="contained"
                      color="primary"
                      style={{
                        padding: "2px 6px",
                        fontSize: "12px",
                        minWidth: "auto",
                      }}
                      onClick={() => handleShowModal(element)}
                    >
                      <VisibilityIcon
                        style={{ margin: "0 2px 0 0", fontSize: "20px" }}
                      />{" "}
                      Mostrar
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <Modal open={showModal} onClose={handleCloseModal}>
        <div className="modal-content">
          {showModal && selectedCliente && (
            <PlantillaScreen
              titulo={selectedCliente.razon_social}
              className={"asc-modal-pedidos-facturados"}
            >
              <div className="modal-content-wrapper">
                <div className="form-container">
                  <Grid container spacing={1}>
                    <Grid container item spacing={1}>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextField
                          label="Folio de la Solicitud"
                          value={selectedCliente.folio || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={6}>
                        <TextField
                          label="Cliente"
                          value={capitalizeWords(
                            selectedCliente.razon_social
                          )}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid container item spacing={1}>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Asesor de Venta"
                            value={selectedCliente.asesor_ventas || "-"}
                            fullWidth
                            margin="normal"
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Sucursal"
                            value={
                              capitalizeWords(selectedCliente.sucursal) ||
                              "-"
                            }
                            fullWidth
                            margin="normal"
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4}>
                          <TextField
                            label="Celular"
                            value={
                              capitalizeWords(selectedCliente.celular) ||
                              "-"
                            }
                            fullWidth
                            margin="normal"
                            InputProps={{ readOnly: true }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>

                    {/* Segunda fila: ID EQUIP, Serie Fiscal, Folio Fiscal, Documento Factura, Documento Pagaré */}
                    <Grid container item spacing={1}>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="ID EQUIP"
                          value={selectedCliente.idequip || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Serie Fiscal"
                          value={selectedCliente.serie_fiscal || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Folio Fiscal"
                          value={selectedCliente.folio_fiscal || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Documento de la Factura"
                          value={selectedCliente.documento_factura || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Documento del Pagaré"
                          value={selectedCliente.documento_pagare || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    </Grid>

                    <Grid container item spacing={1}>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Tasa Anual"
                          value={selectedCliente.tasa + " %" || "-"}
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Días de Financiamiento"
                          value={
                            selectedCliente.dias_financiamiento || "-"
                          }
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Importe a Financiar"
                          value={
                            FormatMoney(
                              selectedCliente.importefinanciar,
                              0
                            ) || "-"
                          }
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Interés Pactado"
                          value={
                            FormatMoney(
                              selectedCliente.interes,
                              0
                            ) || "0"
                          }
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6} md={2.4}>
                        <TextField
                          label="Total a Pagar"
                          value={
                            FormatMoney(selectedCliente.totalpagar, 0) ||
                            "-"
                          }
                          fullWidth
                          margin="normal"
                          InputProps={{ readOnly: true }}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </div>
              <div className="analisis-as-screen-footer">

                <div
                  className="analisis-as-screen-x"
                  onClick={handleCloseModal}
                >
                  X
                </div>
                <div className="button-container">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "5px" }}
                    onClick={() => onImprimirPedido(1)}
                  >
                    <DownloadIcon /> Descargar el Pedido
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "5px" }}
                    onClick={() => onImprimirPedido(2)}
                  >
                    <DownloadIcon />
                    Descargar el Pagaré
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ margin: "5px" }}
                    onClick={() => onImprimirPedido(3)}
                  >
                    <DownloadIcon />
                    Descargar la Factura
                  </Button>
                </div>
              </div>
            </PlantillaScreen>
          )}
        </div>
      </Modal>
    </PlantillaScreen>
  );
};
